import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import type { YieldPreview } from "@/entities/robot";
import { apiPost, qk } from "@/shared/api";

export interface PreviewParams {
  //: Сумма, на которой считается прогон. Это НЕ поле робота: фиксированной
  //: цены у него больше нет, а минимум — порог входа, а не типичный капитал.
  //: Форма подставляет сюда рекомендованную сумму, оператор может её поменять.
  base: string;
  daily_min_pct: string;
  daily_max_pct: string;
  positive_chance: string;
  //: Ставка комиссии: превью обязано пересчитываться при её правке, иначе
  //: оператор сверял бы карточку с доходностью, которой не будет.
  profit_fee_pct: string;
}

/** Диапазон, который бэкенд отвергнет: не гонять заведомо провальный запрос. */
function isValid(params: PreviewParams): boolean {
  const values: string[] = [
    params.base,
    params.daily_min_pct,
    params.daily_max_pct,
    params.positive_chance,
    params.profit_fee_pct,
  ];
  if (values.some((value) => value === "" || !/^-?\d+(\.\d+)?$/.test(value))) return false;
  return Number(params.daily_min_pct) <= 0 && Number(params.daily_max_pct) >= 0;
}

/**
 * Debounce ввода. Без него превью уходит на каждое нажатие клавиши, а лимит
 * на чтение — 60 запросов в минуту на IP, общий на всех операторов.
 */
function useDebounced<T>(value: T, delay = 400): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounced(value);
    }, delay);
    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);
  return debounced;
}

export function useYieldPreview(params: PreviewParams) {
  const debounced = useDebounced(params);
  const enabled = isValid(debounced);

  return useQuery<YieldPreview>({
    queryKey: qk.robotPreview({ ...debounced }),
    enabled,
    // Превью детерминировано: те же параметры дают тот же ответ, пока не
    // сменится соль генератора. Перезапрашивать его при фокусе окна незачем.
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
    queryFn: ({ signal }) => apiPost("/api/v1/admin/robots/preview", { body: debounced, signal }),
  });
}
